import { fromJS } from "immutable";
import { cancelReservation } from "../../utils/witbookingApi";
import { name } from "./__init__";

export const initialState = fromJS({
  ticker: null,
  cancelLoaded: false,
  cancelLoading: false,
  cancelError: false,
});

const CANCEL_RESERVATION = `${name}/CANCEL_RESERVATION`;
const CANCEL_RESERVATION_SUCCESS = `${name}/CANCEL_RESERVATION_SUCCESS`;
const CANCEL_RESERVATION_ERROR = `${name}/CANCEL_RESERVATION_ERROR`;
const SMART_PAYMENT_ID = `${name}/SMART_PAYMENT_ID`;

export default (state = initialState, action) => {
  switch (action.type) {
    case CANCEL_RESERVATION_SUCCESS:
      return state.set("cancelLoading", false).set("cancelLoaded", true).set("cancelError", false);
    case CANCEL_RESERVATION_ERROR:
      return state.set("cancelLoading", false).set("cancelLoaded", true).set("cancelError", true);
    case CANCEL_RESERVATION:
      return state.set("cancelLoaded", false).set("cancelLoading", true).set("cancelError", false);
    case SMART_PAYMENT_ID:
      const id = action.id;
      return state.set("smartPaymentId", id);
    default:
      return state;
  }
};

export function cancelBook(params) {
  const reservationId = params.reservationId;
  const propertyTicker = params.hotelTicker;
  const cancellationReason = params.cancellationReason;
  return {
    types: [CANCEL_RESERVATION, CANCEL_RESERVATION_SUCCESS, CANCEL_RESERVATION_ERROR],
    promise: () => cancelReservation({}, { reservationId, propertyTicker, cancellationReason }),
  };
}

export function isLoaded(globalState) {
  return globalState[name] && globalState[name].get("cancelLoaded");
}

export function setSmartPaymentId(id) {
  return {
    type: SMART_PAYMENT_ID,
    id,
  };
}

export const actions = {
  CANCEL_RESERVATION,
  CANCEL_RESERVATION_SUCCESS,
  CANCEL_RESERVATION_ERROR,
  SMART_PAYMENT_ID,
  cancelBook,
};
